import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import ReactGA from 'react-ga'
import {
  FaChevronDown,
  FaChevronUp,
  FaSearch,
  FaChevronRight,
  FaChevronLeft,
} from 'react-icons/fa'
import logoColor from '../../images/prima-logo.svg'
import Btn from '../buttons/buttons'
import s from './header.module.css'
import Autocomplete from '../autocomplete/autocomplete'
import { default as suggestions } from './pages.json'
import {
  PREFIX_REPOSITORY,
  POSTFIX_REPOSITORY,
  BASE_URL_TRASPASO,
} from '../../constants/URLs'
import phone from '../../images/phone.svg'
import {
  IcoSoyAfiliado,
  IcoEmpezandoAportar,
  IcoAportandoHaceAnyos,
  IcoVoyAjubilarme,
  IcoReciboUnaPension,
  IcoSoyBeneficiario,
  IcoSoyEmpleador,
  IcoCrecerMifondo,
  IcoCuentasMetas,
  IcoAhorroYa,
  IcoQuienEsUnBeneficiario,
  IcoPensionAlimentos,
  IcoSolicitaHerencia,
  IcoSoyPagoAportes,
  IcoFormularioTramites,
  IcoTrabajadoresPesqueros,
  IcoTrabajadoresJubilados,
} from '../../lib/svg'
import { GTMEvents } from '../../lib/GTMevents'

class Header extends React.Component {
  state = {
    menuIsOpen: false,
    searchIsOpen: false,
    clickedParent: null,
    clickedChild: null,
    isDesktop: false,
    colorAfiliate: false,
    colorBeneficiary: false,
    colorEmployer: false,
    colorVolunteer: false,
    urlAffiliate: [
      '/aportes-y-fondo/tipos-de-fondo/',
      '/aportes-y-fondo/tipos-de-aportes/',
      '/aportes-y-fondo/comisiones',
      '/aportes-y-fondo/en-que-invierten-mi-dinero',
      '/aportes-y-fondo/transferencias-de-fondos-al-exterior',
      '/aportes-y-fondo/preguntas-frecuentes',
      '/aportes-y-fondo/uso-del-25-de-mi-fondo-para-un-inmueble',
      '/aportes-y-fondo/tipos-de-aportes/aportes-voluntarios',
      '/aportes-y-fondo/transferencias-de-fondos-al-exterior',
      '/aportes-y-fondo/preguntas-frecuentes/fondos',
      '/aportes-y-fondo/libre-desafiliacion-y-nulidad',
      '/jubilacion-y-pension',
      '/jubilacion-y-pension/modalidades-de-pension',
      '/jubilacion-y-pension/informacion-para-pensionistas',
      '/jubilacion-y-pension/retiro-del-95-de-tu-fondo',
      '/jubilacion-y-pension/cobertura-del-seguro',
      '/jubilacion-y-pension/bono-de-reconocimiento',
      '/jubilacion-y-pension/ley-de-pension-minima',
      '/jubilacion-y-pension/preguntas-frecuentes',
      '/jubilacion-y-pension/informacion-para-pensionistas',
      '/jubilacion-y-pension/informacion-para-pensionistas#documentos-informativos-y-formatos',
    ],
    urlBeneficiary: [
      '/jubilacion-y-pension/fallecimiento/requisitos-y-tramites',
      '/jubilacion-y-pension/fallecimiento/herencia',
      '/jubilacion-y-pension/fallecimiento/pension-por-fallecimiento',
      '/aportes-y-fondo/en-que-invierten-mi-dinero',
      '/aportes-y-fondo/transferencias-de-fondos-al-exterior',
      '/aportes-y-fondo/preguntas-frecuentes',
    ],
    urlEmployer: [
      '/acerca-de-afpnet',
      '/deuda',
      '/comisiones-bancos-y-plazos-de-pago',
      '/formularios-para-tramites',
      '/trabajadores-pesqueros',
      '/trabajadores-jubilados-y-mayores-a-65-anos',
    ],
    urlVolunteer: [
      '/productos/cuenta-metas',
      '/productos/plan-flexible',
      '/aliados-comerciales/sobre-el-programa',
    ],
  }

  handleToggle = (type, index) => {
    if (type === 'parent') {
      if (this.state.clickedParent === index) {
        this.setState({ clickedParent: null })
      }
      this.setState({ clickedParent: index })
    } else {
      if (this.state.clickedChild === index) {
        this.setState({ clickedChild: null })
      }
      this.setState({ clickedChild: index })
    }
  }

  handleSeach = () => {
    const { searchIsOpen } = this.state
    this.setState({
      searchIsOpen: !searchIsOpen,
    })
  }

  handleBtnBackMobile = () =>
    // BTN ATRAS
    [1, 2, 3, 4].some(e => e > 0 && e < 5) &&
    !this.state.isDesktop && (
      <span className={`${s.back_btn}`}>
        <FaChevronLeft
          className="f--3"
          onClick={() =>
            this.setState({ clickedParent: null, clickedChild: null })
          }
        />{' '}
        <span>Atrás</span>
      </span>
    )

  handleIcoArrowFirstLevel = index =>
    this.state.clickedParent !== index && (
      <FaChevronRight className="ml-2 f--3" />
    )

  handleIcoArrowSecondLevel = index =>
    this.state.clickedChild === index ? (
      <FaChevronUp className={`${s.navSecondLevel_ico_right} ml-2 f--5`} />
    ) : (
      <FaChevronDown className={`${s.navSecondLevel_ico_right} ml-2 f--5`} />
    )

  // Abrimos menu Mobile
  handleOpenMenuMobile = () => {
    this.setState({ menuIsOpen: true })
    // id del div de chat
    let eleChatBox = document.querySelector('div[data-id="zsalesiq"]')
    if (eleChatBox) {
      eleChatBox.style.display = 'none'
    }
  }

  // Cerramos menu Mobile
  handleCloseMenuMobile = () => {
    this.setState({
      menuIsOpen: false,
      clickedParent: null,
      clickedChild: null,
    })
    // id del div de chat
    let eleChatBox = document.querySelector('div[data-id="zsalesiq"]')
    if (eleChatBox) {
      eleChatBox.style.display = 'block'
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.handleForCookieBot()
    this.handleCloseMenuMobile() // Cargamos esta funcion para mostrar el chat según casuística de abrir menu y link
    this.handleColorOption(window.location.pathname)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.handleForCookieBot()
  }

  handleClickOutside = e => {
    if (this.node_search.contains(e.target)) {
      return
    }
    this.setState({
      searchIsOpen: false,
    })
  }

  // Función para detectar ruta de página que no debe mostrar el banner cookieBot
  handleForCookieBot = () => {
    let pathNameCurrent = window.location.pathname
    let pathNameCustom = '/politica-de-privacidad/'
    let cookieBanner = document.getElementById('CookieBanner')
    if (cookieBanner) {
      if (pathNameCurrent === pathNameCustom) {
        // Ocultamos Banner CookieBot
        cookieBanner.style.display = 'none'
      } else {
        cookieBanner.style.display = 'block'
      }
    }
  }

  handleResize = () => {
    // Moviendo el DOM del campo Buscador en vista DEKSTOP/MOBILE
    let searchBlock = document.getElementById('search_block')
    let wrapMobileSearchBlock = document.getElementById(
      'wrap_mobile_search_block'
    )
    let wrapDesktopSearchBlock = document.getElementById(
      'wrap_desktop_search_block'
    )
    // SI es DESKTOP
    if (window.innerWidth > 949) {
      // MEDIA min @950
      this.setState({ isDesktop: true })
      wrapDesktopSearchBlock.append(searchBlock)
    } else {
      // SI es MOBILE
      this.setState({ isDesktop: false })
      //wrapMobileSearchBlock.prepend(searchBlock);
    }
  }

  handleColorOption = urlCurrent => {
    //let urlCurrent = window.location.pathname;
    if (this.state.urlAffiliate.includes(urlCurrent)) {
      this.setState({
        colorAfiliate: true,
        colorBeneficiary: false,
        colorEmployer: false,
        colorVolunteer: false,
      })
    } else if (this.state.urlBeneficiary.includes(urlCurrent)) {
      this.setState({
        colorAfiliate: false,
        colorBeneficiary: true,
        colorEmployer: false,
        colorVolunteer: false,
      })
    } else if (this.state.urlEmployer.includes(urlCurrent)) {
      this.setState({
        colorAfiliate: false,
        colorBeneficiary: false,
        colorEmployer: true,
        colorVolunteer: false,
      })
    } else if (this.state.urlVolunteer.includes(urlCurrent)) {
      this.setState({
        colorAfiliate: false,
        colorBeneficiary: false,
        colorEmployer: false,
        colorVolunteer: true,
      })
    }
  }

  render() {
    const stateStyles = {
      openButton: this.state.menuIsOpen
        ? { display: 'none' }
        : { display: 'block' },
      closeButton: this.state.menuIsOpen
        ? { display: 'block' }
        : { display: 'none' },
      navMenu: this.state.menuIsOpen
        ? { display: 'block' }
        : { display: 'none' },
    }
    return (
      <>
        <header
          id="main-header"
          className={`${s.header}`}
        >
          {/* HEADER TOP */}
          <div className={`${s.headerTop}`}>
            <div
              id="wrap_desktop_search_block"
              className={`relative containerWrap pv-3 flex justify-between items-center pv-0@lg`}
            >
              <div
                onClick={() => GTMEvents.HeaderBtnContact('contactanos')}
                className="pv-2 flex items-center justify-between"
              >
                <Link
                  to="/canales-de-atencion/"
                  className="f--1 flex items-center c-gray--1"
                >
                  <img
                    src={phone}
                    className={`${s.searchBtnIco} mr-1`}
                    alt="Clave"
                  />{' '}
                  Contáctanos
                </Link>
              </div>
            </div>
          </div>
          {/* HEADER BASE */}
          <div
            className={`relative containerWrap pv-3 flex justify-between items-center pv-0@lg ${s.headerBase}`}
          >
            <Link
              onClick={() => () =>
                ReactGA.event({
                  category: 'Cabecera',
                  action: 'clic',
                  label: 'logo',
                })}
              to="/"
              className={s.linkLogo}
            >
              <h1>
                <img src={logoColor} className={`${s.logo} `} alt="Prima AFP" />
              </h1>
            </Link>
            <div className={`${s.nav}`}>
              <button
                className={`${s.hamburger}`}
                style={stateStyles.openButton}
                title="Abrir menú"
                onClick={() => this.handleOpenMenuMobile()}
              >
                <span>Menú</span>☰
              </button>
              <button
                className={`${s.close}`}
                style={stateStyles.closeButton}
                title="Cerrar menú"
                onClick={() => this.handleCloseMenuMobile()}
              >
                ✖
              </button>
              <div className={`${s.nav_links}`} style={stateStyles.navMenu}>
                <div className={`${s.menu_wrap}`}>
                  <div
                    id="wrap_mobile_search_block"
                    className={`${s.menu_top}`}
                  >
                    {/* BUSCADOR */}
                    <div
                      id="search_block"
                      ref={node => (this.node_search = node)}
                      className={`${s.searchContainer}`}
                    >
                      {this.state.clickedParent === null && (
                        <>
                          {this.state.isDesktop && (
                            <button
                              className={`${s.buttonSearch} ${
                                this.state.searchIsOpen
                                  ? s.buttonSearch_active
                                  : 'c-gray--1'
                              }`}
                              onClick={this.handleSeach}
                            >
                              <span className={`${s.searchBtnText} f--1 mr-2`}>
                                Buscar
                              </span>{' '}
                              <FaSearch className={`${s.searchBtnIco}`} />
                            </button>
                          )}
                          <Autocomplete
                            isOpen={this.state.searchIsOpen}
                            isDesktop={this.state.isDesktop}
                            suggestions={suggestions.pages}
                            className={` ${
                              this.state.searchIsOpen
                                ? s.search_isOpen
                                : s.search_isClosed
                            } ${s.search_autocomplete}`}
                          />
                        </>
                      )}
                    </div>
                    {/* BUSCADOR */}

                    <ul
                      className={`${s.navFirstLevel} flex@lg pr-0@lg w-100 w-auto@lg`}
                    >
                      {/* 1ST LEVEL - HOME */}
                      <li
                        className={`${
                          this.state.colorAfiliate
                            ? `${s.navFirstLevel_btn} ${s.navFirstLevel_btn_select}`
                            : s.navFirstLevel_btn
                        }`}
                      >
                        {this.handleBtnBackMobile()}

                        <span
                          id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                          className={`${s.navFirstLevel_desktop}`}
                          tabIndex={0}
                        >
                          Soy afiliado
                        </span>

                        <span
                          className={`${s.navFirstLevel_item} ${
                            this.state.clickedParent === 1
                              ? s.submenu_parent_open
                              : s.submenu_parent_close
                          }`}
                          onClick={() =>
                            this.state.clickedParent === 1
                              ? this.setState({
                                  clickedParent: null,
                                  clickedChild: null,
                                })
                              : this.handleToggle('parent', 1)
                          }
                        >
                          <span className={`${s.navFirstLevel_block}`}>
                            <IcoSoyAfiliado
                              className={`${s.navFirstLevel_ico}`}
                            />
                            <span className={`${s.navFirstLevel_text}`}>
                              <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                Soy afiliado
                              </strong>
                              Soy aportante de Prima AFP
                            </span>
                          </span>
                          {this.handleIcoArrowFirstLevel(1)}
                        </span>

                        {/* 2ND LEVEL - SOY AFILIADO */}
                        <ul
                          className={`${s.navSecondLevel} ${
                            s.navSecondLevel_width
                          } ${s.navSecondLevel_widthMedia} c-gray--1 bg-white ${
                            this.state.clickedParent === 1
                              ? s.submenu_open
                              : s.submenu_close
                          }`}
                        >
                          {/* 2ND LEVEL - SOY AFILIADO - MENU*/}
                          <li
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 11 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 11
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 11)
                              }
                            >
                              <span className={`${s.navSecondLevel_block}`}>
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoEmpezandoAportar
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-SUBMENU">
                                    Empezando a aportar
                                  </strong>
                                  Soy nuevo afiliado en Prima AFP
                                </span>
                              </span>
                              {this.handleIcoArrowSecondLevel(11)}
                            </span>
                            {/* 3RD LEVEL - SOY AFILIADO - Empezando a aportar */}
                            <ul
                              className={`${
                                s.navThirdLevel
                              } c-gray--1 bg-white ${
                                this.state.clickedChild === 11
                                  ? s.submenu_open
                                  : s.submenu_close
                              }`}
                            >
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Tipos de fondo'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-SUBMENU-ITEM"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/tipos-de-fondo/'
                                    )
                                  }
                                  to="/aportes-y-fondo/tipos-de-fondo/"
                                >
                                  Tipos de fondo
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Tipos de aportes'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/tipos-de-aportes/'
                                    )
                                  }
                                  to="/aportes-y-fondo/tipos-de-aportes/"
                                >
                                  Tipos de aportes
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Comisiones'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/comisiones'
                                    )
                                  }
                                  to="/aportes-y-fondo/comisiones"
                                >
                                  Comisiones
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'En qué invierten mi dinero'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/en-que-invierten-mi-dinero'
                                    )
                                  }
                                  to="/aportes-y-fondo/en-que-invierten-mi-dinero"
                                >
                                  En qué invierten mi dinero
                                </Link>
                              </li>

                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Transferencia de fondos al exterior'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/transferencias-de-fondos-al-exterior'
                                    )
                                  }
                                  to="/aportes-y-fondo/transferencias-de-fondos-al-exterior"
                                >
                                  Transferencia de fondos al exterior
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Preguntas frecuentes'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/preguntas-frecuentes'
                                    )
                                  }
                                  to="/aportes-y-fondo/preguntas-frecuentes"
                                >
                                  Preguntas frecuentes
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Empezando a aportar',
                                    'Beneficios Prima'
                                  )
                                }
                                className={`${s.navThirdLevel_btn} ${s.navNewLink_wrap}`}
                              >
                                <a
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  target="_blank"
                                  className={`${s.navThirdLevel_block}`}
                                  href="https://www.beneficiosprima.pe/BeneficiosPrimaWeb/"
                                >
                                  Beneficios Prima
                                </a>
                                <span className={`${s.navNewLink}`}>
                                  ¡Nuevo!
                                </span>
                              </li>
                            </ul>
                            {/* 3RD LEVEL - SOY AFILIADO - Empezando a aportar */}
                          </li>
                          <li
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 12 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 12
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 12)
                              }
                            >
                              <span className={`${s.navSecondLevel_block}`}>
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoAportandoHaceAnyos
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Aportando hace unos años
                                  </strong>
                                  Soy afiliado a Prima AFP
                                </span>
                              </span>
                              {this.handleIcoArrowSecondLevel(12)}
                            </span>
                            {/* 3RD LEVEL - SOY AFILIADO - Aportando hace unos años */}
                            <ul
                              className={`${
                                s.navThirdLevel
                              } c-gray--1 bg-white ${
                                this.state.clickedChild === 12
                                  ? s.submenu_open
                                  : s.submenu_close
                              }`}
                            >
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Retiro de fondos para mi vivienda'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/uso-del-25-de-mi-fondo-para-un-inmueble'
                                    )
                                  }
                                  to="/aportes-y-fondo/uso-del-25-de-mi-fondo-para-un-inmueble"
                                >
                                  Retiro de fondos para mi vivienda
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Aportes voluntarios'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/tipos-de-aportes/aportes-voluntarios'
                                    )
                                  }
                                  to="/aportes-y-fondo/tipos-de-aportes/aportes-voluntarios"
                                >
                                  Aportes voluntarios
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Transferencia de fondos al exterior'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/transferencias-de-fondos-al-exterior'
                                    )
                                  }
                                  to="/aportes-y-fondo/transferencias-de-fondos-al-exterior"
                                >
                                  Transferencia de fondos al exterior
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Preguntas frecuentes'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/preguntas-frecuentes/fondos'
                                    )
                                  }
                                  to="/aportes-y-fondo/preguntas-frecuentes/fondos"
                                >
                                  Preguntas frecuentes
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Libre desafiliación y Nulidad'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/aportes-y-fondo/libre-desafiliacion-y-nulidad'
                                    )
                                  }
                                  to="/aportes-y-fondo/libre-desafiliacion-y-nulidad"
                                >
                                  Libre desafiliación y Nulidad
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Aportando hace unos años',
                                    'Beneficios Prima'
                                  )
                                }
                                className={`${s.navThirdLevel_btn} ${s.navNewLink_wrap}`}
                              >
                                <a
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  target="_blank"
                                  className={`${s.navThirdLevel_block}`}
                                  href="https://www.beneficiosprima.pe/BeneficiosPrimaWeb/"
                                >
                                  Beneficios Prima
                                </a>
                                <span className={`${s.navNewLink}`}>
                                  ¡Nuevo!
                                </span>
                              </li>
                            </ul>
                            {/* 3RD LEVEL - SOY AFILIADO - Aportando hace unos años */}
                          </li>
                          <li
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 13 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 13
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 13)
                              }
                            >
                              <span className={`${s.navSecondLevel_block}`}>
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoVoyAjubilarme
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Voy a jubilarme
                                  </strong>
                                  Recibiré mi jubilación y/o pensión
                                </span>
                              </span>
                              {this.handleIcoArrowSecondLevel(13)}
                            </span>
                            {/* 3RD LEVEL - SOY AFILIADO - Voy a jubilarme */}
                            <ul
                              className={`${
                                s.navThirdLevel
                              } c-gray--1 bg-white ${
                                this.state.clickedChild === 13
                                  ? s.submenu_open
                                  : s.submenu_close
                              }`}
                            >
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Tipos de jubilación y pensión'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension'
                                    )
                                  }
                                  to="/jubilacion-y-pension"
                                >
                                  Tipos de jubilación y pensión
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Modalidades de pensión'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/modalidades-de-pension'
                                    )
                                  }
                                  to="/jubilacion-y-pension/modalidades-de-pension"
                                >
                                  Modalidades de pensión
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Ventajas de ser pensionista'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/informacion-para-pensionistas'
                                    )
                                  }
                                  to="/jubilacion-y-pension/informacion-para-pensionistas"
                                >
                                  Ventajas de ser pensionista
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Retiro del 95.5% de tu fondo'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/retiro-del-95-de-tu-fondo'
                                    )
                                  }
                                  to="/jubilacion-y-pension/retiro-del-95-de-tu-fondo"
                                >
                                  Retiro del 95.5% de tu fondo
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Cobertura de seguro'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/cobertura-del-seguro'
                                    )
                                  }
                                  to="/jubilacion-y-pension/cobertura-del-seguro"
                                >
                                  Cobertura de seguro
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Bono de reconocimiento'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/bono-de-reconocimiento'
                                    )
                                  }
                                  to="/jubilacion-y-pension/bono-de-reconocimiento"
                                >
                                  Bono de reconocimiento
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Preguntas frecuentes'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/preguntas-frecuentes'
                                    )
                                  }
                                  to="/jubilacion-y-pension/preguntas-frecuentes"
                                >
                                  Preguntas frecuentes
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Voy a jubilarme',
                                    'Pensión mínima'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <a
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  href="https://estimador-pension-minima.primaafp.pe/inicio"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Pensión mínima
                                </a>
                              </li>
                            </ul>
                            {/* 3RD LEVEL - SOY AFILIADO - Voy a jubilarme */}
                          </li>
                          <li
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 14 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 14
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 14)
                              }
                            >
                              <span className={`${s.navSecondLevel_block}`}>
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoReciboUnaPension
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Recibo una pensión
                                  </strong>
                                  Estoy recibiendo una jubilación y/o pensión
                                </span>
                              </span>
                              {this.handleIcoArrowSecondLevel(14)}
                            </span>
                            {/* 3RD LEVEL - SOY AFILIADO - Recibo una pensión */}
                            <ul
                              className={`${
                                s.navThirdLevel
                              } c-gray--1 bg-white ${
                                this.state.clickedChild === 14
                                  ? s.submenu_open
                                  : s.submenu_close
                              }`}
                            >
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Recibo una pensión',
                                    'Calendario de pagos'
                                  )
                                }
                                className={s.navThirdLevel_btn}
                              >
                                <a
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  href={
                                    PREFIX_REPOSITORY +
                                    '2025/pdf/' +
                                    'Cronograma_pagos_2025.pdf' +
                                    POSTFIX_REPOSITORY
                                  }
                                >
                                  Calendario de pagos
                                </a>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Recibo una pensión',
                                    'Acerca de tu pensión'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/informacion-para-pensionistas'
                                    )
                                  }
                                  to="/jubilacion-y-pension/informacion-para-pensionistas"
                                >
                                  Acerca de tu pensión
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Recibo una pensión',
                                    'Documentos informativos y formatos'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/jubilacion-y-pension/informacion-para-pensionistas#documentos-informativos-y-formatos'
                                    )
                                  }
                                  to="/jubilacion-y-pension/informacion-para-pensionistas#documentos-informativos-y-formatos"
                                >
                                  Documentos informativos y formatos
                                </Link>
                              </li>
                            </ul>
                            {/* 3RD LEVEL - SOY AFILIADO - Recibo una pensión */}
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Actualización de Datos',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <a
                                className={`${s.navSecondLevel_block}`}
                                target="_blank"
                                href="https://misdatos.prima.com.pe/"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoAportandoHaceAnyos
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Actualización de Datos
                                  </strong>
                                </span>
                              </a>
                            </span>
                          </li>
                          {/* 2ND LEVEL - SOY AFILIADO - MENU END*/}
                        </ul>
                        {/* 2ND LEVEL - END */}
                      </li>
                      {/* 1ST LEVEL - END */}
                      {/* 1ST LEVEL - HOME */}
                      <li
                        className={`${
                          this.state.colorBeneficiary
                            ? `${s.navFirstLevel_btn} ${s.navFirstLevel_btn_select}`
                            : s.navFirstLevel_btn
                        }`}
                      >
                        <span
                          id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                          className={`${s.navFirstLevel_desktop}`}
                          tabIndex={0}
                        >
                          Soy beneficiario
                        </span>

                        <span
                          className={`${s.navFirstLevel_item} ${
                            this.state.clickedParent === 2
                              ? s.submenu_parent_open
                              : s.submenu_parent_close
                          }`}
                          onClick={() =>
                            this.state.clickedParent === 2
                              ? this.setState({
                                  clickedParent: null,
                                  clickedChild: null,
                                })
                              : this.handleToggle('parent', 2)
                          }
                        >
                          <span className={`${s.navFirstLevel_block}`}>
                            <IcoSoyBeneficiario
                              className={`${s.navFirstLevel_ico}`}
                            />
                            <span className={`${s.navFirstLevel_text}`}>
                              <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                Soy beneficiario
                              </strong>
                              Soy representante de una afiliado
                            </span>
                          </span>
                          {this.handleIcoArrowFirstLevel(2)}
                        </span>

                        {/* 2ND LEVEL - SOY BENEFICIARIO */}
                        <ul
                          className={`${s.navSecondLevel}  c-gray--1 bg-white ${
                            this.state.clickedParent === 2
                              ? s.submenu_open
                              : s.submenu_close
                          }`}
                        >
                          {/* 2ND LEVEL - SOY BENEFICIARIO - MENU*/}
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                '¿Quién es un beneficiario?',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 21 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 21
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 21)
                              }
                            >
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/jubilacion-y-pension/fallecimiento/beneficiarios'
                                  )
                                }
                                to="/jubilacion-y-pension/fallecimiento/beneficiarios"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoQuienEsUnBeneficiario
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    ¿Quién es un beneficiario?
                                  </strong>
                                  Conoce quiénes pueden recibir una pensión
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Pensión por fallecimiento',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 22 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 22
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 22)
                              }
                            >
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/jubilacion-y-pension/fallecimiento/pension-por-fallecimiento'
                                  )
                                }
                                to="/jubilacion-y-pension/fallecimiento/pension-por-fallecimiento"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoPensionAlimentos
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Pensión por fallecimiento
                                  </strong>
                                  Se otorga a los beneficiarios del afiliado
                                  fallecido
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Solicita una Herencia',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 23 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 23
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 23)
                              }
                            >
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/jubilacion-y-pension/fallecimiento/herencia'
                                  )
                                }
                                to="/jubilacion-y-pension/fallecimiento/herencia"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoSolicitaHerencia
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Solicita una Herencia
                                  </strong>
                                  En caso el afiliado no cuente con
                                  beneficiarios legales
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Cronograma de pagos',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 24 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 24
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 24)
                              }
                            >
                              <a
                                className={`${s.navSecondLevel_block}`}
                                rel="noopener noreferrer"
                                target="_blank"
                                href={
                                  PREFIX_REPOSITORY +
                                  '2025/pdf/' +
                                  'Cronograma_pagos_2025.pdf' +
                                  POSTFIX_REPOSITORY
                                }
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoReciboUnaPension
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Cronograma de pagos
                                  </strong>
                                  Revisa las fechas de pago de tu pensión
                                </span>
                              </a>
                            </span>
                          </li>
                          {/* 2ND LEVEL - SOY BENEFICIARIO - MENU END*/}
                        </ul>
                        {/* 2ND LEVEL - END */}
                      </li>
                      {/* 1ST LEVEL - END */}
                      {/* 1ST LEVEL - HOME */}
                      <li
                        className={`${
                          this.state.colorEmployer
                            ? `${s.navFirstLevel_btn} ${s.navFirstLevel_btn_select}`
                            : s.navFirstLevel_btn
                        }`}
                      >
                        <span
                          id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                          className={`${s.navFirstLevel_desktop}`}
                          tabIndex={0}
                        >
                          Soy empleador
                        </span>

                        <span
                          className={`${s.navFirstLevel_item} ${
                            this.state.clickedParent === 3
                              ? s.submenu_parent_open
                              : s.submenu_parent_close
                          }`}
                          onClick={() =>
                            this.state.clickedParent === 3
                              ? this.setState({
                                  clickedParent: null,
                                  clickedChild: null,
                                })
                              : this.handleToggle('parent', 3)
                          }
                        >
                          <span className={`${s.navFirstLevel_block}`}>
                            <IcoSoyEmpleador
                              className={`${s.navFirstLevel_ico}`}
                            />
                            <span className={`${s.navFirstLevel_text}`}>
                              <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                Soy empleador
                              </strong>
                              Soy parte de una empresa u organización
                            </span>
                          </span>
                          {this.handleIcoArrowFirstLevel(3)}
                        </span>

                        {/* 2ND LEVEL - SOY EMPLEADOR */}
                        <ul
                          className={`${s.navSecondLevel} ${
                            s.navSecondLevel_width
                          } c-gray--1 bg-white ${
                            this.state.clickedParent === 3
                              ? s.submenu_open
                              : s.submenu_close
                          }`}
                        >
                          {/* 2ND LEVEL - SOY EMPLEADOR - MENU*/}
                          <li
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span
                              className={`${s.navSecondLevel_item}  ${
                                this.state.clickedChild === 31 ? s.actived : ''
                              }`}
                              onClick={() =>
                                this.state.clickedChild === 31
                                  ? this.setState({ clickedChild: null })
                                  : this.handleToggle('child', 31)
                              }
                            >
                              <span className={`${s.navSecondLevel_block}`}>
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoSoyPagoAportes
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Pago de aportes
                                  </strong>
                                  Conoce el cálculo del interés moratorio y las
                                  comisiones
                                </span>
                              </span>
                              {this.handleIcoArrowSecondLevel(31)}
                            </span>
                            <ul
                              className={`${
                                s.navThirdLevel
                              } c-gray--1 bg-white ${
                                this.state.clickedChild === 31
                                  ? s.submenu_open
                                  : s.submenu_close
                              }`}
                            >
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Pago de aportes',
                                    'Acerca de AFP Net'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption('/acerca-de-afpnet')
                                  }
                                  to="/acerca-de-afpnet"
                                >
                                  Acerca de AFP Net
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Pago de aportes',
                                    'Deuda'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption('/deuda')
                                  }
                                  to="/deuda"
                                >
                                  Deuda
                                </Link>
                              </li>
                              <li
                                onClick={() =>
                                  GTMEvents.BtnMenuSubmenu(
                                    'Pago de aportes',
                                    'Comisiones, bancos y plazos de pago'
                                  )
                                }
                                className={`${s.navThirdLevel_btn}`}
                              >
                                <Link
                                  id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                                  className={`${s.navThirdLevel_block}`}
                                  onClick={() =>
                                    this.handleColorOption(
                                      '/comisiones-bancos-y-plazos-de-pago'
                                    )
                                  }
                                  to="/comisiones-bancos-y-plazos-de-pago"
                                >
                                  Comisiones, bancos y plazos de pago
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Solicitudes del empleador',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                            tabIndex={0}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/formularios-para-tramites'
                                  )
                                }
                                to="/formularios-para-tramites"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoFormularioTramites
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Solicitudes del empleador
                                  </strong>
                                  Solicita acceso a nuestro Portal del Empleador
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Trabajadores pesqueros',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/trabajadores-pesqueros'
                                  )
                                }
                                to="/trabajadores-pesqueros"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoTrabajadoresPesqueros
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Trabajadores pesqueros
                                  </strong>
                                  Conoce las características especiales para
                                  este régimen
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu(
                                'Trabajadores jubilados y mayores a 65 años',
                                ''
                              )
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/trabajadores-jubilados-y-mayores-a-65-anos'
                                  )
                                }
                                to="/trabajadores-jubilados-y-mayores-a-65-anos"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoTrabajadoresJubilados
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Trabajadores jubilados y mayores a 65 años
                                  </strong>
                                  ¿Debo descontar AFP a mis trabajadores?
                                </span>
                              </Link>
                            </span>
                          </li>
                          {/* 2ND LEVEL - SOY EMPLEADOR - MENU END*/}
                        </ul>
                        {/* 2ND LEVEL - END */}
                      </li>
                      {/* 1ST LEVEL - END */}
                      {/* 1ST LEVEL - HOME */}
                      <li
                        className={`${
                          this.state.colorVolunteer
                            ? `${s.navFirstLevel_btn} ${s.navFirstLevel_btn_select}`
                            : s.navFirstLevel_btn
                        }`}
                      >
                        <span
                          id="GTM-MOD-MEP-BTN-NAVBAR-MENU"
                          className={`${s.navFirstLevel_desktop}`}
                          tabIndex={0}
                        >
                          Aportes voluntarios
                        </span>

                        <span
                          className={`${s.navFirstLevel_item} ${
                            this.state.clickedParent === 4
                              ? s.submenu_parent_open
                              : s.submenu_parent_close
                          }`}
                          onClick={() =>
                            this.state.clickedParent === 4
                              ? this.setState({
                                  clickedParent: null,
                                  clickedChild: null,
                                })
                              : this.handleToggle('parent', 4)
                          }
                        >
                          <span className={`${s.navFirstLevel_block}`}>
                            <IcoCrecerMifondo
                              className={`${s.navFirstLevel_ico}`}
                            />
                            <span className={`${s.navFirstLevel_text}`}>
                              <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                Aportes voluntarios
                              </strong>
                              Quiero conocer los productos de Prima AFP
                            </span>
                          </span>
                          {this.handleIcoArrowFirstLevel(4)}
                        </span>

                        {/* 2ND LEVEL - APORTES VOLUNTARIO */}

                        <ul
                          className={`${s.navSecondLevel} c-gray--1 bg-white ${
                            this.state.clickedParent === 4
                              ? s.submenu_open
                              : s.submenu_close
                          }`}
                        >
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu('Cuenta Metas', '')
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/productos/cuenta-metas'
                                  )
                                }
                                to="/productos/cuenta-metas"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoCuentasMetas
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Aportes voluntarios
                                  </strong>
                                  Invierte en nuestra cuenta de aportes
                                  voluntarios
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu('Plan Flexible', '')
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  this.handleColorOption(
                                    '/productos/plan-flexible'
                                  )
                                }
                                to="/productos/plan-flexible"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoAportandoHaceAnyos
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    Plan Flexible
                                  </strong>
                                  Ten un plan de pensión flexible a tu medida
                                </span>
                              </Link>
                            </span>
                          </li>
                          <li
                            onClick={() =>
                              GTMEvents.BtnMenuSubmenu('AhorroYa!', '')
                            }
                            className={`${s.navSecondLevel_btn}`}
                          >
                            <span className={`${s.navSecondLevel_item}`}>
                              <Link
                                className={`${s.navSecondLevel_block}`}
                                onClick={() =>
                                  ReactGA.event({
                                    category: 'Cabecera',
                                    action: 'clic',
                                    label: 'ahorroya',
                                  })
                                }
                                to="/aliados-comerciales/sobre-el-programa"
                              >
                                <span
                                  className={`${s.navSecondLevel_ico_wrap}`}
                                >
                                  <IcoAhorroYa
                                    className={`${s.navSecondLevel_ico}`}
                                  />
                                </span>
                                <span className={`${s.navSecondLevel_text}`}>
                                  <strong id="GTM-MOD-MEP-BTN-NAVBAR-MENU">
                                    AhorroYa!
                                  </strong>
                                  Beneficio exclusivo para ahorrar con tus
                                  consumos
                                </span>
                              </Link>
                            </span>
                          </li>
                        </ul>

                        {/* 2ND LEVEL - END */}
                      </li>
                      {/* 1ST LEVEL - END */}
                    </ul>
                  </div>

                  <div className={`${s.menu_account} flex@lg justify-end@lg`}>
                    <div
                      onClick={() =>
                        GTMEvents.BtnMenuAccess('Cámbiate a Prima')
                      }
                    >
                      <Btn
                        id="GTM-MOD-MEP-BTN-ACCESS-MENU"
                        className={`mt-0@lg ${s.menu_accountItem} improve-analytics-btn-header`}
                        type="link"
                        href={`${BASE_URL_TRASPASO}/`}
                        label={'Cámbiate a Prima'}
                        color="outlineRed"
                        size="medium"
                      />
                    </div>
                    <div onClick={() => GTMEvents.BtnMenuAccess('Mi cuenta')}>
                      <Btn
                        id="GTM-MOD-MEP-BTN-ACCESS-MENU"
                        className={`mt-3 mt-0@lg ml-0@sm ml-3@lg ${s.menu_accountItem} `}
                        type="link"
                        href="https://miespacio.prima.com.pe/"
                        label={'Mi cuenta'}
                        color="orange"
                        size="medium"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    )
  }
}

Btn.propTypes = {
  type: PropTypes.oneOf(['gatsby-link', 'button', 'link']),
}

export default Header
